module.exports = __webpack_public_path__ + "static/img/200232.e2faaff3.png";